/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Creators_Load_FailedInputs */

const vi_order_export_creators_load_failed = /** @type {(inputs: Order_Export_Creators_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách người tạo đơn. Để trống ô này sẽ xuất đơn của mọi người tạo.`)
};

/**

* @param {Order_Export_Creators_Load_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_creators_load_failed = /** @type {((inputs?: Order_Export_Creators_Load_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Creators_Load_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_creators_load_failed(inputs)
});